module.exports = __webpack_public_path__ + "static/img-features--apotheke-143d36f3e16b43f3ce9e2f72e87d08fa.png";